import { AntdLayout, Button, Card, Col, Icons, Row, notification } from '@pankod/refine-antd';
import { useAuth0 } from '@auth0/auth0-react';
import eloBooksDetailed from 'assets/images/elo-books-details-logo.svg';
import { useState } from 'react';

export const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleLogin = async () => {
    if (isRedirecting) return;

    setIsRedirecting(true);
    try {
      await loginWithRedirect();
    } catch (err: any) {
      setIsRedirecting(false);
      notification.error({
        message: 'Login Failed',
        description: err?.message || 'Could not redirect to Auth0 login.',
      });
    }
  };

  const CardTitle = (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60px',
      }}
    >
      <img src={eloBooksDetailed} alt="Logo" style={{ height: '4rem', width: 'auto' }} />
    </div>
  );

  return (
    <AntdLayout
      style={{
        backgroundColor: '#eff7f7',
      }}
    >
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <Card
            style={{
              maxWidth: '400px',
              margin: 'auto',
            }}
            title={CardTitle}
          >
            <Button
              type="primary"
              size="large"
              block
              disabled={isRedirecting}
              onClick={handleLogin}
              style={{ backgroundColor: '#426DEA' }}
            >
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span>Login</span>
                {isRedirecting && <Icons.LoadingOutlined spin />}
              </span>
            </Button>
          </Card>
        </Col>
      </Row>
    </AntdLayout>
  );
};
